import Controller from "./dateFilter.controller";
import template from "./dateFilter.html";

const dateFilter = {
  template,
  controller: Controller,
  bindings: {
    selected: "<",
    hasRange: "<",
    hasDate: "<",
    eventName: "<",
    title: "@",
    name: "@",
  },
};

export default dateFilter;



// WEBPACK FOOTER //
// ./src/components/dateFilter/dateFilter.component.js